import api from './api';

const base = (clientId) => `/api/v1/clients/${clientId}/documents`;

export const getDocuments = (clientId) =>
  api.get(base(clientId)).then((r) => r.data.data.documents);

export const uploadDocument = (clientId, file, description = '') => {
  const formData = new FormData();
  formData.append('file', file);
  if (description) formData.append('description', description);
  return api
    .post(base(clientId), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data.data.document);
};

export const downloadDocument = async (clientId, documentId, fileName) => {
  const response = await api.get(`${base(clientId)}/${documentId}/download`, {
    responseType: 'blob',
  });
  const url = URL.createObjectURL(response.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const deleteDocument = (clientId, documentId) =>
  api.delete(`${base(clientId)}/${documentId}`).then((r) => r.data);
